// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Units Page Styles */

/* Additional custom styles can be added here if needed */
/* Most styling is handled by Material UI's sx prop */
`, "",{"version":3,"sources":["webpack://./src/pages/Catalog/Units/Units.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB,yDAAyD;AACzD,qDAAqD","sourcesContent":["/* Units Page Styles */\n\n/* Additional custom styles can be added here if needed */\n/* Most styling is handled by Material UI's sx prop */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
